import { Model as e } from "../../../../../model.js";
class o extends e {
  constructor(s) {
    super(), this.latitude = s.latitude, this.longitude = s.longitude, this.address = s.address;
  }
}
export {
  o as ShopSessionAddressModel
};
//# sourceMappingURL=address.model.js.map
